// extracted by mini-css-extract-plugin
module.exports = {"clickableCard":"ClickableCard_clickableCard__36_um","activeKeypress":"ClickableCard_activeKeypress__1oTs0"};